import React from 'react';
import cn from 'classnames';
import style from './index.module.scss';
interface SProps {
  type?: number;
  title: string;
  desc: string;
  mDesc?: string;
  image: string;
  imgHost?: string;
  titleClass?: string;
  imgClass?: string;
  textClass?: string;
  descClass?: string;
}

const Specialty = (props: SProps) => {
  const { type = 1, title, desc, image, imgHost = '', titleClass, imgClass, textClass, descClass, mDesc } = props;
  return (
    <div className={style.specialty}>
      <div className={style.content}>
        <div className={cn(style['specialty-text'], textClass, type !== 1 && style.order)}>
          <div className={cn(style.title, titleClass)}>{title}</div>
          <div className={cn(style.desc, descClass, 'for-pc')} dangerouslySetInnerHTML={{ __html: desc.replace(/\n/g, '<br>') }}></div>
          <div className={cn(style.desc, descClass, 'for-mobile')} dangerouslySetInnerHTML={{ __html: (mDesc || desc).replace(/\n/g, '<br>') }}></div>
        </div>
        <img className={cn(style.fullImg, imgClass)} src={imgHost + image} alt="" />
      </div>
    </div>
  );
};

export default Specialty;
